module.exports = [
  { title: 'asset Types', path: 'assetTypes' },
  { title: 'attribute Definitions', path: 'attributeDefinitions' },
]
